import{a as t}from"./chunk-EI7MMDWY.js";var o=t(r=>r.replace(/\w+/g,e=>e[0].toUpperCase()+e.slice(1).toLowerCase()),"titleCase");export{o as a};
